export default {"src":"/_next/static/image/src/images/Homepage/box-food-packs.13907055e4a7cfe38826adf652d50775.svg","height":73,"width":202};